//#region Util Imports

import * as _ from 'underscore'
import * as moment from 'moment'
import * as $ from 'jquery'

//#endregion

import { ColumnModel } from "../../../../../api/api.models"
import { LocalizationHelper, TypeHelper } from "../../../../../../helpers"
import { Enums } from "../../../../../../models/common"
import { UserSessionService } from "../../../../../../services/user-session"
import { OpDataType } from "app/models/core"
import { CreateEditFieldSettings } from 'app/modules/common/common.create-edit'



//#region Public Types

export const ALZ_ACTION_SERVICE_NAME = 'alzActionService'
export const ALZ_ACTION_SERVICE_PROVIDER_NAME = 'alzActionServiceProvider'

//#endregion

export class AlzActionService {


    // #region Ctor

    constructor(private userSessionService: UserSessionService) { }

    // #endregion

    // #region Public Methods

    public getFormColumns(additionalDataTypes: Enums.DataType[]): JQueryPromise<CreateEditFieldSettings[]> {
        const columns: CreateEditFieldSettings[] = []

        let dataTypesToGet: Enums.DataType[] = [
            Enums.DataType.DALI_LAMP_OFF_MINUTES,
            Enums.DataType.DALI_LAMP_ON_MINUTES,
            Enums.DataType.DALI_LIGHT_SENSOR_SUNRISE_TIME_RANGE,
            Enums.DataType.DALI_LIGHT_SENSOR_SUNSET_TIME_RANGE,
            Enums.DataType.LIGHT_SENSOR_ENABLED,
            Enums.DataType.LIGHT_SENSOR_ON_LUMINOSITY_LEVEL,
            Enums.DataType.ASTRONOMICAL_CLOCK_ENABLED,
            Enums.DataType.ASTRONOMICAL_CLOCK_SUNRISE_OFFSET,
            Enums.DataType.ASTRONOMICAL_CLOCK_SUNSET_OFFSET,
        ]

        dataTypesToGet.push(...additionalDataTypes)
        dataTypesToGet = _.uniq(dataTypesToGet)

        return this.userSessionService
            .getDataProvider()
            .DataType
            .getDataTypes(dataTypesToGet)
            .then((dataTypes: OpDataType[]) => {
                _.forEach(dataTypes, (dataType: OpDataType) => {
                    if (dataType != null && dataType.idDataType !== Enums.DataType.LIGHT_SENSOR_ENABLED && dataType.idDataType !== Enums.DataType.ASTRONOMICAL_CLOCK_ENABLED) {
                        const tmpColumn: CreateEditFieldSettings = {
                            id: dataType.idDataType,                            
                            isEditable: true,
                            caption: dataType.toString(),
                            format: dataType.dataTypeFormat,
                            type: dataType.idDataType == Enums.DataType.DALI_LAMP_OFF_MINUTES || dataType.idDataType == Enums.DataType.DALI_LAMP_ON_MINUTES ? Enums.DataTypeClass.Time : dataType.idDataTypeClass,
                            unitName: dataType.unit != null ? dataType.unit.toString() : TypeHelper.emptyString,
                            referenceTypeId: dataType.idReferenceType,
                            hint: dataType.descr != null && dataType.descr.extendedDescription != null ? dataType.descr.extendedDescription : ''
                        }

                        columns.push(tmpColumn)
                    }
                })

                return columns
            })
    }


    // #endregion
}
